import { NSARouterMakerResult, NSAHomePage } from "namirasoft-account-react";
import { CredentialLayout } from '../CredentialLayout';
import { CredentialProps } from "../CredentialProps";

interface HomePageProps extends NSARouterMakerResult, CredentialProps { }

export default function HomePage(props: HomePageProps)
{
    return (
        <CredentialLayout {...props}>
            <NSAHomePage  {...props} />
        </CredentialLayout>
    );
}